module.exports = __webpack_public_path__ + "static/media/relatorios.6e947342.png";